import type { LandingDict } from './en';

const id: LandingDict = {
  nav: { chat: 'Chat Apps', agentic: 'Agentic Apps', build: 'Buat App', org: 'My Org', pricing: 'Harga', privacy: 'Privasi', contact: 'Kontak', language: 'Bahasa' },
  hero: {
    titlePre: 'Pusat kekuatan\n',
    titleMark: 'AI lokal',
    titlePost: ' Anda.',
    sub: 'Ubah pengetahuan pakar, spreadsheet, dan rapat menjadi jawaban, grafik, dan presentasi. Tidak ada yang keluar dari Mac Anda.',
    watch: 'Tonton film 2 menit',
    pill: 'Rilis terbaru',
    chip: 'Wi‑Fi mati · 0 byte terkirim',
    badges: { offline: 'Berfungsi tanpa internet', server: 'Server Anda, bukan milik kami', free: 'Gratis untuk memulai' },
    reqs: 'Memerlukan Mac dengan Apple Silicon · Memori minimal 16GB · 32GB+ untuk model rekomendasi yang lebih besar',
  },
  stats: {
    free: 'Gratis',
    freeSub: 'Semua Chat Apps, unduhan model, dan pembaruan — selamanya',
    chatApps: 'Chat Apps',
    agenticApps: 'Agentic Apps',
    bytesSub: 'byte terkirim ke cloud saat AI berjalan di Mac ini',
    langsSub: 'bahasa antarmuka, dari Bahasa Indonesia hingga 日本語',
  },
  film: { kicker: 'Filmnya', title: 'Lihat Estha beraksi.', watchOnYouTube: 'Tonton di YouTube', trouble: 'Tidak bisa diputar? Tonton di YouTube ↗' },
  overview: {
    kicker: 'Satu app, empat cara bekerja',
    title: 'Dari chat, ke agen,\nhingga app untuk seluruh tim.',
    explore: 'Jelajahi',
    chat: { title: 'Chat Apps', desc: 'Pakar AI yang berlandaskan basis pengetahuan pilihan — buku teks, panduan kerja, dan keahlian bidang.', tag: 'Selalu gratis' },
    agentic: { title: 'Agentic Apps', desc: 'Agen AI berorientasi tugas yang menangani pekerjaan kompleks dari awal hingga akhir.', tag: '{n} dan terus bertambah' },
    build: { title: 'Buat App', desc: 'Ubah materi Anda sendiri menjadi Chat App dengan Quick Bot, atau susun alur di kanvas Playground.', tag: 'Quick Bot · Playground' },
    org: { title: 'My Org', desc: 'Ruang app milik organisasi Anda dengan merek sendiri, berisi app yang sudah ditinjau dan akses yang terkendali.', tag: 'Enterprise' },
  },
  chat: {
    kicker: 'Chat Apps',
    title: 'AI pakar, berlandaskan pengetahuan nyata.',
    freePill: 'Selalu gratis',
    lede: 'Setiap Chat App hadir dengan basis pengetahuannya sendiri, diindeks langsung di Mac Anda.',
    feats: {
      kb: { title: 'Basis pengetahuan lokal', desc: 'Memasang app akan membuat basis pengetahuannya secara lokal — jawaban berasal dari materi pilihan.' },
      files: { title: 'Gunakan file Anda sendiri', desc: 'Lampirkan gambar, PDF, DOCX, TXT, atau MD — dokumen panjang memakai pencarian cerdas.' },
      browse: { title: 'Jelajahi, sematkan, favoritkan', desc: 'Kategori dari Asesmen hingga Karier, label NEW untuk app terbaru, ⌘K untuk mencari apa saja.' },
    },
  },
  agentic: {
    kicker: 'Agentic Apps',
    title: '{n} Agentic Apps.\nDan terus bertambah.',
    lede: 'Dari spreadsheet, PDF, rekaman, atau sebuah ide menjadi grafik, presentasi, dokumen, atau prototipe yang siap pakai — secara privat di Mac Anda.',
    seeThem: 'Lihat cara kerjanya',
  },
  build: {
    kicker: 'Buat App',
    title: 'Buat Chat App Anda sendiri.\nLangsung di Mac Anda.',
    lede: 'Ubah file Anda menjadi Chat App — diindeks secara lokal, dipublikasikan saat Anda siap.',
    quick: {
      badge: 'Direkomendasikan',
      desc: 'Unggah basis pengetahuan dan tulis system prompt, lalu publikasikan. Cocok untuk mengubah materi menjadi bot tanya jawab dengan cepat.',
      items: ['Formulir satu halaman, selesai dalam beberapa langkah', 'Tanya jawab berbasis pengetahuan langsung siap pakai', 'Templat prompt bawaan untuk inspirasi'],
    },
    advanced: {
      title: 'Lanjutan · Playground',
      desc: 'Editor node visual untuk menyusun banyak node, cabang, AB test, dan perutean kata kunci secara bebas.',
      items: ['Kanvas node', 'Multi-node / cabang / AB test', 'Kolom terperinci & debugging'],
    },
    guideTitle: 'Panduan AI lokal mendampingi Anda saat membangun.',
    guideText: 'Ceritakan apa yang ingin dilakukan app Anda, dan panduan akan menunjukkan node mana yang perlu diseret dan cara menghubungkannya. Fitur membangun app sudah termasuk dalam Premium.',
  },
  private: {
    kicker: 'Privat sejak awal',
    title: 'Tanpa cloud untuk data Anda.\nTanpa pelacakan atas pekerjaan Anda.',
    lede: 'Anda yang menentukan di mana AI berjalan. Secara default, Estha memilih model yang tepat untuk setiap fitur — dan Anda bisa mengganti model kapan saja di dalam app.',
    boundary: 'Batas data = jaringan Anda',
    local: { title: 'Di Mac ini', desc: 'Sepenuhnya offline, tidak ada yang keluar dari mesin ini. Model berjalan menggunakan memori komputer ini.', best: 'Paling cocok untuk Mac dengan memori besar' },
    server: { title: 'Di Estha Server saya', desc: 'Alihkan pekerjaan berat ke Mac yang lebih bertenaga di jaringan Anda, agar Mac ini tetap ringan.', best: 'Paling cocok untuk laptop dan Mac dengan memori terbatas' },
    cluster: { desc: 'Hubungkan ke kluster Mac Studio untuk mengalihkan inferensi berat sambil tetap menyimpan data di lokasi Anda sendiri.', best: 'Otomatis menemukan node Estha Studio Master di jaringan Anda' },
    models: {
      every: 'Berjalan di semua Mac yang didukung',
      whisper: 'Whisper untuk transkripsi',
      recommended: 'Model yang direkomendasikan',
      larger: 'Model Qwen dan Gemma yang lebih besar',
      vision: 'Model vision untuk gambar',
      open: 'Model terbuka, dioptimalkan untuk Apple Silicon',
      openItems: ['Unduh dan ganti model di dalam app', 'Model khusus untuk kode & embedding', 'Unduhan model selalu gratis'],
    },
  },
  org: {
    kicker: 'My Org',
    title: 'Ruang app AI milik organisasi Anda.',
    lede: 'Bagian bermerek di dalam Estha yang berisi app yang telah ditinjau organisasi Anda untuk anggotanya.',
    signIn: 'Masuk ke My Org Admin',
    talk: 'Hubungi tim Estha',
    feats: {
      review: { title: 'Ditinjau sebelum dipublikasikan', desc: 'Setiap app baru, pembaruan, atau penghapusan diteruskan ke admin. Penolakan selalu disertai masukan tertulis.' },
      access: { title: 'Akses per grup atau per orang', desc: 'Tentukan dengan tepat siapa yang bisa melihat setiap app — per departemen, tim, atau individu.' },
      brand: { title: 'Merek Anda, di dalam app', desc: 'Nama organisasi, pesan sambutan, logo, banner, dan warna tema — bisa dipratinjau sebelum ditayangkan.' },
    },
  },
  pricing: {
    kicker: 'Keanggotaan',
    title: 'Mulai gratis. Buka semua fitur saat Anda siap.',
    free: { name: 'Gratis', sub: 'Selalu gratis.', items: ['Semua Chat Apps', 'Document Processing, gratis selamanya', 'Unduhan model, perangkat lunak, dan pembaruan — selalu gratis'] },
    premium: {
      name: 'Premium', flag: 'Uji coba gratis 14 hari', firstYear: 'tahun pertama',
      sub: 'Selanjutnya $30/tahun. Mulai dengan uji coba gratis 14 hari setelah memverifikasi email Anda.',
      items: ['Semua fitur Gratis', 'Semua Agentic Apps saat ini dan yang akan datang', 'Pembuat Chat App — buat, edit, pratinjau, simpan, dan publikasikan chatbot lokal'],
      cta: 'Mulai uji coba di dalam app',
    },
    enterprise: {
      name: 'Enterprise', price: 'Mari berdiskusi', sub: 'Untuk organisasi yang menerapkan Estha ke tim-timnya.',
      items: ['Semua fitur Premium', 'Chat Apps dan Agentic Apps khusus yang dibuat untuk tim Anda', 'Kemampuan app Estha Server', 'Ruang app My Org dan My Org Admin'],
    },
  },
  faq: {
    title: 'Yang perlu diketahui\nsebelum mengunduh.',
    spec: { chip: 'Chip', memory: 'Memori', memMin: 'Minimal 16GB', memRec: '32GB+ untuk model yang direkomendasikan', languages: 'Bahasa', langsVal: '13 bahasa antarmuka', version: 'Versi terbaru' },
    qa: [
      { q: 'Apakah ada data yang keluar dari Mac saya?', a: 'Saat AI berjalan di Mac ini, semuanya sepenuhnya offline — tidak ada yang keluar dari mesin ini. Jika Anda memilih Estha Server atau kluster Mac Studio, pekerjaan hanya dikirim ke mesin tersebut di jaringan Anda sendiri.' },
      { q: 'Apa saja yang memerlukan koneksi internet?', a: 'Hanya beberapa hal: masuk dan memverifikasi email untuk uji coba Premium, mengunduh model, dan memeriksa pembaruan. Prompt, file, dan hasil Anda tidak pernah diunggah — setelah model diunduh, AI bekerja sepenuhnya offline.' },
      { q: 'Apa yang gratis, dan apa yang termasuk Premium?', a: 'Semua Chat Apps, Document Processing, unduhan model, dan pembaruan gratis. Premium membuka semua Agentic Apps saat ini dan yang akan datang, ditambah pembuat Chat App, dengan uji coba gratis 14 hari.' },
      { q: 'Model AI apa yang digunakan?', a: 'Model open-source terkemuka seperti Qwen dan Gemma, ditambah Whisper untuk transkripsi, yang dijalankan melalui mesin MLX dari Apple. Anda bisa mengunduh dan menggantinya di dalam app.' },
      { q: 'Bisakah saya membuat app sendiri?', a: 'Bisa. Gunakan Quick Bot untuk mengubah hingga tiga file menjadi Chat App berbasis pengetahuan dalam beberapa langkah, atau kanvas node Playground untuk cabang, AB test, dan kuis. Panduan pembuatan lokal akan membantu Anda di sepanjang proses.' },
      { q: 'Bagaimana organisasi menerapkannya?', a: 'Dengan Enterprise, admin mengelola pengguna dan grup di My Org Admin serta meninjau setiap app sebelum dipublikasikan, dan anggota mendapatkan ruang My Org bermerek di dalam Estha. Hubungi {email}.' },
    ],
  },
  final: { title: 'Siap menjalankan AI secara lokal?', reqs: 'Berjalan di Mac apa pun dengan Apple Silicon · RAM minimal 16GB' },
  footer: {
    tagline: 'Pusat kekuatan AI lokal Anda — di perangkat, didukung MLX, privat sejak awal.',
    product: 'Produk', createApp: 'Buat App', pricing: 'Harga',
    orgs: 'My Org', signIn: 'Masuk ke My Org Admin',
    security: 'Keamanan', changelog: 'Catatan perubahan', docs: 'Dokumentasi', support: 'Dukungan',
    company: 'Perusahaan', privacy: 'Kebijakan Privasi', terms: 'Ketentuan Layanan',
    rights: '© 2026 Estha. Hak cipta dilindungi undang-undang.',
  },
  proof: { press: 'Diliput oleh', voices: 'Kata tim pengguna' },
  contact: {
    title: 'Kirim email ke tim Estha', copy: 'Salin alamat email', copied: 'Tersalin',
    gmail: 'Tulis di Gmail', mailApp: 'Buka di app Mail',
    subject: 'Pertanyaan tentang Estha for Mac',
  },
  share: {
    button: 'Bagikan', title: 'Bagikan Estha',
    sub: 'Pilih kartu, lalu posting — atau cukup kirim tautannya.',
    style: 'Kartu', size: 'Ukuran',
    templates: { hero: 'Estha', agentic: 'Agentic Apps', private: 'Privat' },
    landscape: 'Lanskap', portrait: 'Potret',
    shareImage: 'Bagikan gambar…', download: 'Unduh gambar', copyImage: 'Salin gambar', copied: 'Tersalin',
    copyLink: 'Salin tautan', link: 'Tautan', postTo: 'Posting ke',
    email: 'Email',
    text: 'Estha menjalankan model AI open-source sepenuhnya di Mac Anda — privat, offline, dan gratis diunduh.',
    cardCta: 'Unduh gratis untuk Mac dengan Apple Silicon',
    close: 'Tutup',
  },
  apps: {
    dataAnalyst: { name: 'Data Analyst', description: 'Unggah file CSV/Excel dan ajukan pertanyaan dalam bahasa sehari-hari. Otomatis membuat grafik, analisis statistik, dan wawasan data — semuanya diproses secara lokal di Mac Anda.', tags: ['CSV / Excel', 'Grafik Otomatis', 'Kueri Bahasa Alami', 'EN / 中文'] },
    pptMaker: { name: 'PPT Maker', description: 'Jelaskan topik presentasi Anda dan dapatkan deck PowerPoint dengan struktur profesional. Pipeline AI multi-langkah membuat kerangka, isi per slide, dan file .pptx yang rapi.', tags: ['Output .pptx', 'Tata Letak Otomatis', 'Pipeline Multi-langkah'] },
    pdfReader: { name: 'PDF Reader', description: 'Buka PDF dan mengobrol dengannya. Setiap jawaban berlandaskan dokumen, dengan kutipan yang bisa diketuk untuk langsung menuju bagian sumber yang tepat — semuanya diproses secara lokal di Mac Anda.', tags: ['Tanya Jawab PDF', 'Kutipan Terverifikasi', 'Tanya dari Seleksi', '100% Lokal'] },
    documentProcessing: { name: 'Document Processing', description: 'Pakar dokumen serba bisa Anda. Tulis artikel blog, konten media sosial, klausul hukum, dan dokumen bisnis dari nol. Edit dan optimalkan file yang ada, terjemahkan antarbahasa, dan tinjau kualitas konten — semuanya secara privat di Mac Anda.', tags: ['Penyusunan & Penulisan', 'Penyuntingan & Optimasi', 'Terjemahan', 'Tinjauan & Audit'] },
    meetingIntelligence: { name: 'Meeting Intelligence', description: 'Rekam, transkripsikan, dan analisis rapat dengan AI. Otomatis membuat notulen, daftar tindak lanjut, dan keputusan penting — dengan privasi penuh, audio tidak pernah keluar dari perangkat Anda.', tags: ['Transkripsi', 'Notulen Rapat', 'Tindak Lanjut', '100% Privat'] },
    vibeCoding: { name: 'Vibe Coding: Prototype', description: 'Buat pratinjau interaktif dengan AI. Jelaskan antarmuka dalam bahasa sehari-hari, dapatkan prototipe yang bisa diklik, dan terus sempurnakan. Menghasilkan satu file .html mandiri, dibuat sepenuhnya di Mac Anda.', tags: ['Satu File .html', 'Pratinjau Interaktif', 'Tunjuk untuk Edit', '100% Lokal'] },
    translate: { name: "Terjemahkan", description: "Terjemahkan teks serta dokumen Word, teks, atau Markdown dengan glosarium bersama yang menjaga istilah tetap konsisten, semuanya diproses secara lokal di Mac Anda.", tags: ["Teks & Dokumen", ".docx / .txt / .md", "Glosarium", "100% Lokal"] },
  },
  screens: {
    chat: [
      { label: 'Jelajahi toko', caption: 'Jelajahi, pasang, sematkan — selalu gratis' },
      { label: 'Pasang', caption: 'Basis pengetahuan dibuat secara lokal saat dipasang' },
      { label: 'Tanya', caption: 'Jawaban berlandaskan panduannya sendiri' },
    ],
    build: [
      { label: 'Buat App', caption: 'Quick Bot atau Lanjutan — keduanya siap untuk chat' },
      { label: 'Quick Bot', caption: 'Unggah basis pengetahuan. Tulis prompt. Publikasikan.' },
      { label: 'Playground', caption: 'Node, cabang, dan pengetahuan — secara visual' },
      { label: 'Dipublikasikan', caption: 'Sudah dipublikasikan dan siap untuk chat' },
    ],
    analyst: [
      { label: 'Ajukan pertanyaan', caption: 'Tanyakan data Anda dalam bahasa sehari-hari' },
      { label: 'Menganalisis', caption: 'Dianalisis di Mac Anda' },
      { label: 'Grafik & wawasan', caption: 'Jawabannya, grafiknya, dan cara mendapatkannya' },
    ],
    ppt: [
      { label: 'Atur', caption: 'Topik, slide, bahasa, gaya bahasa, tema' },
      { label: 'Tinjau kerangka', caption: 'Edit kerangka sebelum apa pun dibuat' },
      { label: 'Pratinjau deck', caption: 'File .pptx jadi yang bisa diedit — di Mac Anda' },
    ],
    pdf: [
      { label: 'Buka PDF', caption: 'Makalah, laporan, manual, dan dokumen hasil pindaian' },
      { label: 'Membaca', caption: 'Dibaca secara lokal, halaman demi halaman' },
      { label: 'Jawaban berkutipan', caption: 'Setiap jawaban menunjuk ke klausul yang tepat' },
    ],
    doc: [
      { label: 'Pilih bagian teks', caption: 'Pilih teks dan katakan apa yang Anda inginkan' },
      { label: 'Menulis ulang', caption: 'Ditulis ulang langsung di dalam dokumen' },
      { label: 'Terima atau tolak', caption: 'Tulis ulang, poles, terjemahkan — terima atau tolak' },
    ],
    meeting: [
      { label: 'Rekam', caption: 'Transkrip langsung, di Mac ini' },
      { label: 'Pilih output', caption: 'Pilih apa yang ingin dibuat' },
      { label: 'Ringkasan', caption: 'Keputusan dan tindak lanjut, ditulis untuk Anda' },
      { label: 'Tindak lanjut', caption: 'Penanggung jawab dan tenggat waktu, lengkap dengan bukti' },
    ],
    vibe: [
      { label: 'Jelaskan', caption: 'Jelaskan antarmuka dalam bahasa sehari-hari' },
      { label: 'Membuat', caption: 'Dibuat sepenuhnya di Mac ini' },
      { label: 'Prototipe', caption: 'Bisa diklik, berversi, satu file .html' },
      { label: 'Tunjuk untuk edit', caption: 'Pilih bagian mana pun dan katakan apa yang perlu diubah' },
    ],
    translate: [
      { label: "Terjemahkan teks", caption: "Kata berwarna ungu berasal dari glosarium Anda" },
      { label: "Terjemahkan dokumen", caption: ".docx, .txt, atau .md — file asli tidak diubah" },
      { label: "Glosarium", caption: "Glosarium menjaga setiap istilah tetap konsisten" },
    ],
    private: [
      { label: 'Di Mac ini', caption: 'Sepenuhnya offline. Tidak ada yang keluar dari mesin ini.' },
      { label: 'Mac Studio Cluster', caption: 'Model yang lebih berat — di lokasi Anda sendiri' },
    ],
    org: [
      { label: 'Ruang app organisasi', caption: 'Ruang bermerek, app yang dibuat untuk tim' },
      { label: 'Paket Enterprise', caption: 'Anggota hanya membuka app yang Anda izinkan' },
    ],
  },
};

export default id;
